<template>
	<popup
		v-model="selfDisplay"
		title="设置卡片状态"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">总计卡数</span>
				<el-input :value="`${ ids.length }张`" disabled></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>卡片状态</span>
				<el-select v-model="state" placeholder="请选择"  style="width: 100%;">
					<el-option v-for="v in cardState" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="stateTip"><i class="b_icon"></i>请选择卡片状态</template></div>
		</div>
	</popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			ids: {
				type: Array,
				default: () => []
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				selfDisplay: false,
				loading: false,
				
				state: '',
				stateTip: false
			}
		},
		computed: {
			...mapState([
				'cardState'
			])
		},
		methods: {
			// 点击确定
			handleConfirmClick() {
				const that = this;
				if (!that.state.toString()) {
					that.stateTip = true;
					return false;
				} else {
					that.stateTip = false;
				}
				that.loading = true;
				let requestData = {
					cardIds: that.ids,
					cardSmallType: that.state
				};
				Api.setCardState(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit('changeDisplay', newVal);
				if (!newVal) {
					this.loading = false;
					this.state = '';
					this.stateTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
